module.exports = __webpack_public_path__ + "static/media/case-study-question-bg.eb8bcedb.png";